












































import { Vue, Component, Model, Prop, Watch } from "vue-property-decorator";
import User from "@/data/models/User";
import { ClientFilter } from "@/data/models/ClientFilter";
import Client from "@/data/models/Client";
import { getClientName } from "@/data/repository/ClientRepository";
import { COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND } from "@/utils/colors";

@Component
export default class ClientFilterSelectorComponent extends Vue {
  @Prop({ default: null })
  targetUser!: User | null;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: () => new Map<string, Client>() })
  memberClients!: Map<string, Client>;

  @Watch("targetUser")
  onUserChanged(after: User | null, before: User | null) {
    const didUserChange = before != null && before?.id !== after?.id;

    if (didUserChange) {
      const defaultFilter = this.allClientFilters[0];

      if (defaultFilter) {
        this.onSelectedClientFilterChanged(defaultFilter);
      }
    }
  }

  get selectedValues() {
    const keySelected = this.getClientOptionKeyCallback(
      this.selectedClientFilter
    );

    return [keySelected];
  }

  get showSelector() {
    return this.allClientFilters.length > 1;
  }

  get allClientFilters() {
    return this.clientFilters;
  }

  get clientSelectionIcon() {
    return "mdi-office-building-marker";
  }

  @Model("selectedClientFilter")
  selectedClientFilter!: ClientFilter;

  onSelectedClientFilterChanged(newFilter: ClientFilter) {
    this.$emit("selectedClientFilter", newFilter);

    localStorage.removeItem("clientFilter");
    localStorage.removeItem("isDefaultClientFilter");

    if (newFilter?.client?.id) {
      localStorage.setItem("clientFilter", newFilter.client.id);
    }
    else {
      localStorage.setItem("isDefaultClientFilter", "true");
    }
  }

  getClientOptionKeyCallback(clientFilter: ClientFilter) {
    return clientFilter?.client?.id ?? "all";
  }

  getClientFilterName(clientFilter: ClientFilter) {
    return clientFilter.client
      ? getClientName(clientFilter.client)
      : this.$t("common.all");
  }

  get style() {
    const hasSelectedFirstOption =
      this.getClientOptionKeyCallback(this.allClientFilters[0]) ==
      this.getClientOptionKeyCallback(this.selectedClientFilter);

    return hasSelectedFirstOption
      ? ""
      : `background-color: ${COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND}`;
  }

  get clientFilters() {
    if (this.memberClients.size < 1) {
      return [];
    }

    const addAllClientsFilter = this.memberClients.size > 1;

    const result = addAllClientsFilter
      ? [new ClientFilter(...this.memberClients.values())]
      : [];

    this.memberClients.forEach((client) =>
      result.push(new ClientFilter(client))
    );

    return result;
  }
}
